import { toSafeString } from '@shared/utils';

const getInteractionEventId = (event = {}) => {
  return toSafeString(event?.interactionId || event?.approvalId || event?.id);
};

export default getInteractionEventId;
